export default __webpack_public_path__ + "static/media/recover-white-icon.42c2b303.png";